import { NewsletterForm } from '@/components/site/NewsletterForm';
import { useSeo } from '@/lib/seo';

export default function NewsletterPage() {
  useSeo({
    title: 'The Field Report | A Guy Who Hunts',
    description:
      'Video updates, trail-camera notes, scouting observations, mistakes, and honest results — sent only when there is something worth sharing.',
  });

  return (
    <div>
      <section className="relative border-b border-[hsl(var(--border))] hero-radial">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center">
          <p className="kicker">Newsletter</p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-2 leading-tight">
            The Field Report.
          </h1>
          <p className="mt-4 text-[hsl(var(--muted-foreground))] max-w-2xl mx-auto">
            Sent when there is something worth sharing. No daily spam. No manufactured drama.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 sm:p-8 card-elev">
          <h2 className="font-serif text-2xl tracking-tight">What you might receive</h2>
          <ul className="mt-4 grid gap-2 text-sm text-[hsl(var(--foreground))]">
            <li>— New video announcements</li>
            <li>— Trail-camera updates</li>
            <li>— Scouting observations</li>
            <li>— Short field notes</li>
            <li>— Season progress</li>
            <li>— Mistakes and lessons</li>
            <li>— Occasional gear or filming updates</li>
          </ul>
          <div className="mt-8">
            <NewsletterForm variant="full" />
          </div>
          <p className="mt-4 text-xs text-[hsl(var(--muted-foreground))]">
            Your email is used only to send The Field Report. It is never sold, shared, or resold. Unsubscribe any time
            via any email you receive.
          </p>
        </div>
      </section>
    </div>
  );
}
